import AuthenticationModel from "@api/models/AuthenticationModel";
import BaseFormStore from "@components/common/form/stores/BaseFormStore";
import RegistrationForm from "@components/membership/forms/RegistrationForm";
import RootStore from "@stores/RootStore";
import { AxiosError } from "axios";
import { action, makeObservable, observable } from "mobx";
import Registration from "../models/Registration";
import RegistrationService from "../services/RegistrationService";

export default class RegistrationStore extends BaseFormStore {
    rootStore: RootStore;
    service: RegistrationService
    form: RegistrationForm;

    constructor(rootStore: RootStore) {
        super({
            fnGet: async (itemId) => { }
        })
        this.rootStore = rootStore;
        this.service = new RegistrationService();

        this.form = new RegistrationForm(
            {
                onSuccess: () => {
                    this.onFormSuccess();
                },
                onError() { }
            },
            {},
            rootStore);

        makeObservable(this, {
            //#region UI
            isLoading: observable,
            setIsLoading: action,

            //#endregion
            onFormSuccess: action,
            registerAsync: action
        })
    }

    //#region UI

    isLoading: boolean = false;
    setIsLoading = (value: boolean) => {
        this.isLoading = value
    }

    //#endregion

    onFormSuccess = async () => {
        var values = this.form.values()
        if (this.isCreateNewMode) {
            await this.registerAsync(values);
        }
    }

    checkEmailAddressAsync = async (emailAddress: string) => {
        try {
            var response = await this.service.checkEmailAddressAsync(emailAddress);
            if (response.status === 200) {
                return false;
            }
        } catch (ex) {
            if (ex instanceof AxiosError) {
                if (ex.response?.status === 404) {
                    return true;
                }
                else {
                    this.rootStore.toastStore.alert(
                        "error",
                        "Dogodila se neočekivana greška.",
                        "Molimo pokušaj ponovo.")
                }
            }

        }

    }

    registerAsync = async (userToRegister: Registration) => {
        try {
            this.setIsLoading(true);

            userToRegister.cityId = "usJWyc8Rmo3CIuP82wdHzD";

            var response = await this.service.registerAsync(userToRegister);
            if (response.status === 200) {
                var userToLogin = response.data[0];

                var authenticationModel: AuthenticationModel = {
                    userName: userToLogin.emailAddress,
                    password: userToLogin.password
                }

                await this.rootStore.authenticationStore.loginAsync(authenticationModel);
                this.rootStore.routerStore.navigate("/");
            }

        } catch (ex) {
            if (ex instanceof AxiosError) {
                if (ex.response?.status === 400) {
                    this.rootStore.toastStore.alert(
                        "error",
                        "Dogodila se neočekivana greška.",
                        "Molimo pokušaj ponovo.")
                }
                else {
                    this.rootStore.toastStore.alert(
                        "error",
                        "Dogodila se neočekivana greška.",
                        "Molimo pokušaj ponovo.")
                }
            }
        } finally {
            this.setIsLoading(false);
        }
    }
}